import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const PanelColor = () => {

    let location = useLocation();

    const [oldColor, setOldColor] = useState("cyan");
    const [openClose, setOpenClose] = useState({
        display: "none"
    })

    const colorObj = (color) => {
        return (
            {
                "color": color
            }
        )
    };

    useEffect(() => {
        localStorage.setItem("Fon-Color", JSON.stringify(colorObj("cyan")))
    })

    const mytheme = (color) => {
        localStorage.setItem("Fon-Color", JSON.stringify(colorObj(color)));
        document.getElementById('wrapper').classList.replace(oldColor, color);
        setOldColor(color);
    }

    const colorPanel = () => {
        if (openClose.display === "none") {
            setOpenClose({});
        } else {
            setOpenClose({
                display: "none"
            })
        }
        document.getElementById("panel-admin").animate({ width: 'toggle' }, 100);
    }

    return (
        <div id="panel">
            <div id="panel-admin" style={openClose}>
                <div className="panel-admin-box">
                    <div id="tootlbar_colors">
                        <Link to={location.pathname} className="color" style={{ backgroundColor: "#ff8a00" }} onClick={() => mytheme("orange")}></Link>
                        <Link to={location.pathname} className="color" style={{ backgroundColor: "#1abac8" }} onClick={() => mytheme("cyan")}></Link>
                        <Link to={location.pathname} className="color" style={{ backgroundColor: "#b4de50" }} onClick={() => mytheme("lightgreen")}></Link>
                        <Link to={location.pathname} className="color" style={{ backgroundColor: "#e54e53" }} onClick={() => mytheme("red")}></Link>
                        <Link to={location.pathname} className="color" style={{ backgroundColor: "#1abc9c" }} onClick={() => mytheme("green")}></Link>
                        <Link to={location.pathname} className="color" style={{ backgroundColor: "#159eee" }} onClick={() => mytheme("blue")}></Link>
                    </div>
                </div>

            </div>
            <button className="btn p-0 open" style={{ cursor: "pointer" }} onClick={colorPanel}><span><i className="fas fa-cog fa-spin"></i></span></button>
        </div>
    )
}
export default PanelColor